(function () {
  var STORAGE_KEY = "mystore_wishlist_v1";

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateCount(list.length);
    document.dispatchEvent(new CustomEvent("wishlist:updated", { detail: { items: list } }));
  }

  function updateCount(count) {
    var n = typeof count === "number" ? count : read().length;
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      el.textContent = "(" + n + ")";
    });
  }

  function has(handle) {
    return read().some(function (item) { return item.handle === handle; });
  }

  function toggle(product) {
    if (!product || !product.handle) return false;
    var list = read();
    var idx = list.findIndex(function (item) { return item.handle === product.handle; });
    var added = false;
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.unshift({
        handle: product.handle,
        id: product.id,
        title: product.title,
        url: product.url,
        image: product.image || "",
        price: product.price || 0,
        compare_at_price: product.compare_at_price || 0,
        available: product.available !== false,
        variant_id: product.variant_id || null
      });
      added = true;
    }
    write(list);
    syncButtons();
    return added;
  }

  function remove(handle) {
    write(read().filter(function (item) { return item.handle !== handle; }));
    syncButtons();
  }

  function money(cents) {
    if (window.MyStoreCart && window.MyStoreCart.formatMoney) {
      return window.MyStoreCart.formatMoney(cents);
    }
    return "Rs. " + (Number(cents) / 100).toFixed(2);
  }

  function syncButtons() {
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-product-handle");
      var active = has(handle);
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.setAttribute("title", active ? "Remove from wishlist" : "Add to wishlist");
    });
  }

  function productFromButton(btn) {
    return {
      handle: btn.getAttribute("data-product-handle"),
      id: Number(btn.getAttribute("data-product-id") || 0),
      title: btn.getAttribute("data-product-title") || "",
      url: btn.getAttribute("data-product-url") || ("/products/" + btn.getAttribute("data-product-handle")),
      image: btn.getAttribute("data-product-image") || "",
      price: Number(btn.getAttribute("data-product-price") || 0),
      compare_at_price: Number(btn.getAttribute("data-product-compare") || 0),
      available: btn.getAttribute("data-product-available") !== "false",
      variant_id: Number(btn.getAttribute("data-variant-id") || 0) || null
    };
  }

  function renderWishlistPage() {
    var page = document.querySelector("[data-wishlist-page]");
    if (!page) return;
    var grid = page.querySelector("[data-wishlist-grid]");
    var empty = page.querySelector("[data-wishlist-empty]");
    var summary = page.querySelector("[data-wishlist-summary]");
    var list = read();

    if (!list.length) {
      if (grid) grid.innerHTML = "";
      if (empty) empty.hidden = false;
      if (summary) summary.textContent = "0 saved products";
      return;
    }

    if (empty) empty.hidden = true;
    if (summary) summary.textContent = list.length + (list.length === 1 ? " saved product" : " saved products");

    grid.innerHTML = list.map(function (item) {
      var save = item.compare_at_price > item.price
        ? Math.round(((item.compare_at_price - item.price) / item.compare_at_price) * 100)
        : 0;
      var title = (item.title || "").replace(/</g, "&lt;").replace(/"/g, "&quot;");
      return (
        '<article class="product-card wishlist-card" data-wishlist-item="' + item.handle + '">' +
          '<button type="button" class="wishlist-btn is-active" data-wishlist-remove="' + item.handle + '" aria-label="Remove from wishlist">' +
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" stroke="currentColor" stroke-width="1.4"><path d="M12 20s-7-4.4-7-9.2A3.8 3.8 0 0 1 12 7.8 3.8 3.8 0 0 1 19 10.8C19 15.6 12 20 12 20Z"/></svg>' +
          "</button>" +
          '<a class="product-card__media" href="' + item.url + '">' +
            (item.image
              ? '<img src="' + item.image + '" alt="' + title + '" width="350" height="350" loading="lazy">'
              : '<div class="product-card__placeholder"></div>') +
            (save > 0 ? '<span class="product-card__badge">🏷 SAVE ' + save + "%</span>" : "") +
          "</a>" +
          '<div class="product-card__body">' +
            "<h3><a href=\"" + item.url + "\">" + title + "</a></h3>" +
            '<p class="product-card__price">' +
              '<span class="product-card__from">From ' + money(item.price) + "</span>" +
              (item.compare_at_price > item.price ? "<s>" + money(item.compare_at_price) + "</s>" : "") +
            "</p>" +
            (item.available && item.variant_id
              ? '<button type="button" class="btn btn--black btn--sm product-card__atc" data-quick-add data-variant-id="' + item.variant_id + '">Add to cart</button>'
              : '<a class="btn btn--outline btn--sm product-card__atc" href="' + item.url + '">View product</a>') +
          "</div>" +
        "</article>"
      );
    }).join("");
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      toggle(productFromButton(btn));
      return;
    }

    var removeBtn = e.target.closest("[data-wishlist-remove]");
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      remove(removeBtn.getAttribute("data-wishlist-remove"));
      renderWishlistPage();
    }
  });

  window.MyStoreWishlist = {
    read: read,
    write: write,
    has: has,
    toggle: toggle,
    remove: remove,
    syncButtons: syncButtons,
    updateCount: updateCount,
    renderPage: renderWishlistPage
  };

  document.addEventListener("DOMContentLoaded", function () {
    updateCount();
    syncButtons();
    renderWishlistPage();
  });
})();
